module.exports = __webpack_public_path__ + "static/img/fefco713_2.9642704.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/fefco713_2.png
// module id = 5NMC
// module chunks = 0